export default "__VITE_ASSET__DrohclnT__"